import React from 'react';
import { Section } from './Section';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    title: 'Reset',
    desc: 'Use the mineral stack to signal your kidneys to release excess sodium and trapped water.'
  }, {
    num: '02',
    title: 'Flush',
    desc: "Follow the 7-day meal plan to eliminate the 'white poisons' that cause facial swelling."
  }, {
    num: '03',
    title: 'Sculpt',
    desc: 'Apply the 5-minute manual drainage techniques to physically move fluid out of the face.'
  }];
  return <Section bg="white" data-id="element-107">
      <div className="text-center mb-16" data-id="element-108">
        <h2 className="text-4xl md:text-5xl font-serif mb-4" data-id="element-109">How It Works</h2>
        <p className="text-lg text-charcoal/60" data-id="element-110">
          A simple, 3-step daily protocol.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-111">
        {steps.map((step, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2
      }} className="relative p-8 rounded-3xl bg-sage-light text-center group hover:bg-sage transition-colors duration-500" data-id="element-112">
            <div className="text-6xl font-serif text-sage/20 mb-4 group-hover:text-white/20 transition-colors duration-500" data-id="element-113">
              {step.num}
            </div>
            <h3 className="text-2xl font-serif mb-4 group-hover:text-white transition-colors duration-500" data-id="element-114">
              {step.title}
            </h3>
            <p className="text-charcoal/70 group-hover:text-white/90 transition-colors duration-500 leading-relaxed" data-id="element-115">
              {step.desc}
            </p>
          </motion.div>)}
      </div>
    </Section>;
}